/* eslint-disable */
import createIcon from '../createIcon';

const IconSwitch = createIcon({
  name: 'icon-switch',
  content: '<title>ic_切换</title><defs><rect id="icon-switch-a" x="0" y="0" width="16" height="16"/></defs><g stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1539.000000, -6456.000000)"><g transform="translate(498.000000, 6169.000000)"><g transform="translate(111.000000, 287.000000)"><g transform="translate(930.000000, 0.000000)"><mask id="icon-switch-b" fill="currentColor"><use xlink:href="#icon-switch-a"/></mask><use fill="currentColor" opacity="0" xlink:href="#icon-switch-a"/><path d="M15,10 L15,11 L2.426,11 L6.33,14.7928932 L5.62289322,15.5 L1,11 L1,10 L15,10 Z M10.3771068,0.5 L15,5 L15,6 L1,6 L1,5 L13.574,5 L9.67,1.20710678 L10.3771068,0.5 Z" fill="currentColor" fill-rule="nonzero" mask="url(#icon-switch-b)"/></g></g></g></g></g>',
  width: 16,
  height: 16
}, 'Icon');
export default IconSwitch;
